import React from "react";
import { Col, Row } from "react-bootstrap";
import GenericStars from "@frameworks/salesjourney/components/Generic/Star";
export var RatingsStarsBlock = function (props) {
    return (React.createElement("div", { className: "profile-stars-block" },
        props.ratingnumber > 0 ? (React.createElement("span", { className: "txt_yellow" },
            React.createElement(GenericStars, { ratingnumber: props.ratingnumber, isratingnumberpresent: true, isstarspresent: true }))) : (""),
        props.clientcount &&
            Number(props.clientcount) >= 1 &&
            props.clientcount && (React.createElement("span", { className: "DMSanN_14_400" },
            props.clientcount,
            Number(props.clientcount) > 1 ? " Clients" : " Client"))));
};
var dataCheck = new Map();
export var RatingCard = function (props) {
    React.useEffect(function () {
        validateRatingStars();
    }, [props]);
    var validateRatingStars = function () {
        if (props.data) {
            props.data.map(function (rating) {
                dataCheck.set(rating.title, false);
                rating.data.map(function (subtitle) {
                    if (subtitle.value != "0" && subtitle.value != "") {
                        dataCheck.set(rating.title, true);
                    }
                });
            });
        }
    };
    return (React.createElement(React.Fragment, null, props.data &&
        props.data.map(function (rating, idx) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Row, { className: "Rating-card-block mx-0 px-0" },
                    React.createElement(Col, { className: "rating-card-toptile DMSan_16_700 txt-midnight-blue px-0" },
                        React.createElement("div", null,
                            rating.title,
                            "\u00A0\u00A0",
                            rating.currentRatingDate && (React.createElement("span", { className: "DMsanR_11_400 txt_primaryGrey" },
                                "(as on ",
                                rating.currentRatingDate,
                                ")")))),
                    React.createElement(Col, { className: "px-0 bg-dark-lightblue  rating-card-middletile  txt-midnight-blue \n                  ".concat(dataCheck.get(rating.title)
                            ? "displayFlex DMSansMedium_11_500"
                            : "flexCenter DMSan_26_700") }, dataCheck.get(rating.title)
                        ? rating.data &&
                            rating.data.map(function (subtitle, subId) {
                                return (React.createElement(React.Fragment, null,
                                    React.createElement(Col, null, subtitle.text)));
                            })
                        : "NA"),
                    React.createElement(Col, { className: "px-0 rating-card-bottomtile DMSan_26_700 txt-midnight-blue " }, rating.data &&
                        rating.data.map(function (subtitle, subId) {
                            return (React.createElement(React.Fragment, null,
                                React.createElement(Col, null, subtitle.value != "0" ? (React.createElement(React.Fragment, null,
                                    subtitle.value,
                                    (subtitle === null || subtitle === void 0 ? void 0 : subtitle.ascdesccount) && (React.createElement("span", { className: "DMSan_22_700" },
                                        "(", subtitle === null || subtitle === void 0 ? void 0 :
                                        subtitle.ascdesccount,
                                        ")")),
                                    subtitle.ratingStatus !== "" &&
                                        subtitle.ratingStatus == "Up" ? (React.createElement("span", { className: "txt_green" },
                                        React.createElement("i", { className: "edel-icon-arrow-up-fillcolor" }))) : (""),
                                    subtitle.ratingStatus !== "" &&
                                        subtitle.ratingStatus !== "Up" ? (React.createElement("span", { className: "txt_bloodRed" },
                                        React.createElement("i", { className: "edel-icon-arrow-down-fillcolor" }))) : (""))) : (dataCheck.get(rating.title) && "NA"))));
                        })))));
        })));
};
